import { render, staticRenderFns } from "./UltimateTzScanner.vue?vue&type=template&id=adba5a42&"
import script from "./UltimateTzScanner.vue?vue&type=script&lang=js&"
export * from "./UltimateTzScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports